import { render, staticRenderFns } from "./ADANotifyConfig.vue?vue&type=template&id=55a8d294&"
import script from "./ADANotifyConfig.vue?vue&type=script&lang=js&"
export * from "./ADANotifyConfig.vue?vue&type=script&lang=js&"
import style0 from "./ADANotifyConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports